// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\nh6[data-v-5bf149aa] {\n  color: var(--dark-green-100, #002e2a);\n  font-style: normal;\n  font-weight: 500;\n  line-height: 100%;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
